import SiteLink from "common/ui/SiteLink";

export function getNotificationLink(link: string, isCustomer: boolean): LinkDetails {
    const details: LinkDetails = {
        url: null,
        isExternal: false
    };

    if (link != null) {
        const linkParts = link.split(':');
        switch (linkParts[0]) {
            case "ViewOffer":
                details.url = SiteLink.UrlResolver.forOfferDetails(linkParts[1]);
                break;
            case "ViewBidEditor":
                details.url = SiteLink.UrlResolver.forBidEditor();
                break;
            case "ViewContract":
                details.url = SiteLink.UrlResolver.forContractDetails(linkParts[1]);
                break;
            case "ViewDocumentSignature":
                if (isCustomer) {
                    details.url = SiteLink.UrlResolver.forDocuments();
                }
                else {
                    details.url = SiteLink.UrlResolver.forEsign();
                }
                break;
            default:
                details.url = link;
                details.isExternal = true;
                break;
        }
    }

    return details;
}

export interface LinkDetails {
    url: string;
    isExternal: boolean;
}